/**
 *
 * @param itemDiscount The item discount to format
 * @returns the formatted item discount to be send to svc-order
 */
function formatItemDiscount(itemDiscount: App.Checkout.ItemDiscount): App.Checkout.FormattedItemDiscount {
  const appliedVoucher = itemDiscount.appliedVoucher?.map((voucher) => ({
    item_id: voucher.itemId,
    voucher_id: voucher.voucherId,
    voucher_reward_id: voucher.voucherRewardId,
    voucher_title: voucher.voucherTitle,
    voucher_description: voucher.voucherDescription,
    amount: voucher.amount,
    remaining_amount_after: voucher.remainingAmountAfter,
    voucher_user_id: voucher.voucherUserId,
  }))

  return {
    item_id: itemDiscount.itemId,
    offer_id: itemDiscount.offerId,
    category_bk: itemDiscount.categoryBK,
    sub_category_bk: itemDiscount.subCategoryBK,
    discount_value: itemDiscount.discountValue,
    discount_type: itemDiscount.discountType,
    discount_amount: itemDiscount.discountAmount,
    discountable_total: itemDiscount.discountableTotal,
    hide_discount_percentage: itemDiscount.hideDiscountPercentage,
    item_info_string: itemDiscount.itemInfoString,
    applied_voucher: appliedVoucher,
  }
}

export default formatItemDiscount
